import { render, staticRenderFns } from "./dianbofang.vue?vue&type=template&id=cd6fe27a&scoped=true"
import script from "./dianbofang.vue?vue&type=script&lang=js"
export * from "./dianbofang.vue?vue&type=script&lang=js"
import style0 from "./dianbofang.vue?vue&type=style&index=0&id=cd6fe27a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6fe27a",
  null
  
)

export default component.exports